module.exports = __webpack_public_path__ + "static/img/main2.f03b3e47.gif";